module.exports = __webpack_public_path__ + "img/item.f626a2bd.png";